import { log } from '../functions/logging';

import type { Metric, Counter, Histogram } from './types';

export function buildCounter(
  name: string,
  action: (metric: Metric) => void
): Counter {
  return {
    inc: (labels: Record<string, string>, value = 1): void => {
      log({ title: 'Metrics', context: ['Counter', { name, labels, value }] });

      action({
        name,
        labels,
        value,
      });
    },
  };
}

export function buildHistogram(
  name: string,
  buckets: number[],
  action: (metrics: Metric[]) => void
): Histogram {
  return {
    observe: (labels: Record<string, string>, value: number): void => {
      log({
        title: 'Metrics',
        context: ['Histogram', { name, labels, value }],
      });

      const metrics: Metric[] = [];

      // Increment the total count
      metrics.push({
        name: `${name}_count`,
        labels,
        value: 1,
      });

      // Increment the total sum
      metrics.push({
        name: `${name}_sum`,
        labels,
        value,
      });

      // Add all buckets with appropriate values (0 or 1)
      buckets.forEach((bucket) => {
        metrics.push({
          name: `${name}_bucket`,
          labels: { ...labels, le: bucket.toString() },
          value: value <= bucket ? 1 : 0,
        });
      });

      // Increment the +Inf bucket
      metrics.push({
        name: `${name}_bucket`,
        labels: { ...labels, le: '+Inf' },
        value: 1,
      });

      // Send all metrics at once
      action(metrics);
    },
  };
}
